// File for logic corresponding to employeeDetail component
import EmployeeDetail from './employeeDetail';

const employeeDetailConfig = {
  name: 'employeeDetail',
  class: EmployeeDetail,
  querySelector: {
    contactButton: '.employee__contact-button',
  },
};

export default employeeDetailConfig;
